/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useState,useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import * as EmailValidator from 'email-validator';
import { ERR_EMAIL, ERR_EMAIL_INVALID, NEW_USER_ERROR_INVALID_FIRST_NAME, NEW_USER_ERROR_INVALID_LAST_NAME, ORG_ADMIN_PLACEHOLDER_EMAIL, ORG_ADMIN_PLACEHOLDER_FIRST_NAME, ORG_ADMIN_PLACEHOLDER_LAST_NAME, UPDATE_USER_ERROR_FIRST_NAME, UPDATE_USER_ERROR_LAST_NAME } from 'src/constants/constant';
import { TextField, Select, MenuItem, FormControl, InputLabel, FormHelperText } from '@mui/material';
import { addUserData } from 'src/services/userService';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { getAllRoles } from 'src/services/roleService';
import '../Styles/muiglobal.css';

interface UserFormInputs {
    "firstName": string;
    "lastName": string;
    "email": string;
    "roleId":number;
    "createdBy"?: number;
}

interface Role {
    roleId: number;
    roleName: string;
}

interface PropsType {
    closeModal: () => void;
    refreshPage: () => void;
}

interface ApiResponse {
    status: number;
    data: {
        result: number;
        messages: string;
    };
    
}

interface RoleApiResponse {
    status: number;
    data: {
        data: Role[];
    };
}

const validationSchema = Yup.object().shape({
    // firstName: Yup.string().required(UPDATE_USER_ERROR_FIRST_NAME).matches(/^[a-zA-Z0-9\s]*$/, NEW_USER_ERROR_INVALID_FIRST_NAME),
    firstName: Yup.string().required(UPDATE_USER_ERROR_FIRST_NAME).matches(/^[a-zA-Z]+(['-][a-zA-Z]+)*$/, NEW_USER_ERROR_INVALID_FIRST_NAME),
    lastName: Yup.string().required(UPDATE_USER_ERROR_LAST_NAME).matches(/^[a-zA-Z]+(['-][a-zA-Z]+)*$/, NEW_USER_ERROR_INVALID_LAST_NAME),
    email: Yup.string()
        .required(ERR_EMAIL)
        .email(ERR_EMAIL_INVALID)
        .test(
            'is-valid-email',
            ERR_EMAIL_INVALID,
            (value) => value === '' || EmailValidator.validate(value),
        ),
    roleId: Yup.number().required('Role is required'),
});

function AddUserForm({closeModal, refreshPage}: PropsType): JSX.Element {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [roles, setRoles] = useState< Role[]>([]);
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm<UserFormInputs>({
        resolver: yupResolver(validationSchema),
        mode: 'onSubmit',
    });

    useEffect(() => {
        if(roles.length==0)
        {
            getAllRoles()
            .then(
                (response: RoleApiResponse) => {
                    if (response.status === 200) {
                        const roleListArr: Role[] =[];
                        response.data.data.map((role:Role) => {
                            roleListArr.push(role)
                        })
                        setRoles(roleListArr)
                    }
                }
            )
            .catch(
                error => console.log("Error in fetching users: ", error)
            )
        }
        
    }, [roles]);
    
    const onSubmit = async (data: UserFormInputs): Promise<void> => {
        data.createdBy = 1
        setIsLoading(true)
        await addUserData(data)
            .then(
                (res: ApiResponse) => {
                    console.log(res)
                    if(res.status === 200) {
                        if(res.data.result === 1) {
                            
                            NotificationManager.success("User addedd successfully")
                            refreshPage()
                        } else {
                            if(res.data.messages === "Email address exists in the system") {
                                
                                NotificationManager.error("Email address already exists")
                            }
                           
                        }
                        
                    }
                }
            )
            .catch(
                error => {
                    console.log("error", error)
                    
                    NotificationManager.error("Unknown error has occurred")
                }
            )
            .finally(() => {
                console.log("done")
                setIsLoading(false)
            })
    }

    return (
        <React.Fragment>

            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    void handleSubmit(onSubmit)(e);
                }}
            >
                <div className="relative px-[16px] pt-[10px]">
                    <div className="mb-[30px]">
                        <Controller
                            name="firstName"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    fullWidth
                                    label="First Name"
                                    autoComplete="off"
                                    placeholder={ORG_ADMIN_PLACEHOLDER_FIRST_NAME}

                                    error={Boolean(errors.firstName)}
                                    helperText={errors.firstName?.message}
                                />
                            )}
                        />
                    </div>
                    <div className="mb-[30px]">
                        <Controller
                            name="lastName"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    fullWidth
                                    label="Last Name"
                                    autoComplete="off"
                                    placeholder={ORG_ADMIN_PLACEHOLDER_LAST_NAME}

                                    error={Boolean(errors.lastName)}
                                    helperText={errors.lastName?.message}
                                />
                            )}
                        />
                    </div>
                    <div className="mb-[30px]">
                        <Controller
                            name="email"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    fullWidth
                                    label="Email"
                                    autoComplete="off"
                                    placeholder={ORG_ADMIN_PLACEHOLDER_EMAIL}

                                    error={Boolean(errors.email)}
                                    helperText={errors.email?.message}
                                />
                            )}
                        />
                    </div>
                    <div className="mb-[30px]">
                        <Controller
                            name="roleId"
                            control={control}
                            render={({ field }) => (
                                <FormControl fullWidth>
                                    <InputLabel>Role</InputLabel>
                                    <Select
                                        {...field}
                                        label="Role"
                                        error={Boolean(errors.roleId)}
                                        MenuProps={{ className: 'custom-dropdown' }}
                                        onChange={(e) => field.onChange(e.target.value)}
                                    >
                                        {roles.map((role) => (
                                            <MenuItem key={role.roleId} value={role.roleId}>
                                                {role.roleName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {errors.roleId && (
                                        <FormHelperText className="MuiFormHelperText-root Mui-error">{errors.roleId.message}</FormHelperText>
                                    )}
                                </FormControl>
                            )}
                        />
                    </div>
                </div>
                <div className="flex items-center fixed left-0 bottom-0 w-[100%]">
                    <button type="button" className="w-[50%] bg-white h-[55px] border border-inputborder text-muted flex font-semibold text-[15px] items-center justify-center" disabled={isLoading} onClick={closeModal}>
                        Cancel
                    </button>
                    <button type="submit" className="w-[50%] h-[55px] bg-gradient-to-b border-0 from-[#ED4B52] to-[#D6242C] h-[55px text-white flex font-semibold text-[15px] items-center justify-center" disabled={isLoading}>
                        {!isLoading ? 'Save' : <span className="loading loading-spinner loading-xs text-white"></span>}
                    </button>
                </div>
            </form>


        </React.Fragment>
    )
}

export default AddUserForm